export const uniqueId = () => `id_${Math.random().toFixed(10)}`;
